import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#decodeDoubleEncodedEntities();
    this.querySelectorAll('table').forEach(this.#formatTable);
    if (this.hasAttribute('data-h4-accordions')) {
      this.#buildH4Accordions();
    }
  }

  #decodeDoubleEncodedEntities() {
    const entityPattern = /&[a-zA-Z#][a-zA-Z0-9]*;/;
    const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
    const textarea = document.createElement('textarea');
    let node;
    while ((node = walker.nextNode())) {
      if (entityPattern.test(node.textContent)) {
        textarea.innerHTML = node.textContent;
        const decoded = textarea.value;
        if (decoded !== node.textContent) {
          node.textContent = decoded;
        }
      }
    }
  }

  #buildH4Accordions() {
    const h4s = [...this.querySelectorAll('h4')];
    if (!h4s.length) return;

    for (const h4 of h4s) {
      const details = document.createElement('details');
      details.classList.add('rte-accordion');

      const summary = document.createElement('summary');
      summary.classList.add('rte-accordion__trigger');
      // Keep the h4 element so all heading CSS variables apply automatically
      const heading = h4.cloneNode(true);
      summary.appendChild(heading);
      details.appendChild(summary);

      const body = document.createElement('div');
      body.classList.add('rte-accordion__body');

      // Collect all siblings until the next heading
      let next = h4.nextElementSibling;
      while (next && !/^H[1-6]$/.test(next.tagName)) {
        const toMove = next;
        next = next.nextElementSibling;
        body.appendChild(toMove);
      }

      details.appendChild(body);
      h4.replaceWith(details);
    }
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
